"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TileTypes;
(function (TileTypes) {
    TileTypes["Action"] = "Action";
    TileTypes["Foundation"] = "Foundation";
    TileTypes["HQ"] = "HQ";
    TileTypes["Module"] = "Module";
    TileTypes["Soldier"] = "Soldier";
})(TileTypes = exports.TileTypes || (exports.TileTypes = {}));
var ActionTiles;
(function (ActionTiles) {
    ActionTiles["Battle"] = "Battle";
    ActionTiles["Castling"] = "Castling";
    ActionTiles["Move"] = "Move";
    ActionTiles["PushBack"] = "PushBack";
    ActionTiles["Rotation"] = "Rotation";
    ActionTiles["Sniper"] = "Sniper";
    ActionTiles["Terror"] = "Terror";
})(ActionTiles = exports.ActionTiles || (exports.ActionTiles = {}));
